import React from 'react';
import { useStatusTransition } from '../hooks/useStatusTransition';

interface StatusFlashProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 实体当前状态；从运行态翻转为 completed/failed 时容器闪烁一次 */
  status: string;
  /** 自定义运行态集合，缺省用共享 PROCESSING_STATUSES */
  processingStatuses?: readonly string[];
}

/**
 * 状态翻转高亮容器：轮询把状态刷成 completed/failed 时，容器闪烁提示，
 * 用户不必逐条找"哪条完成了"。就是一个 div，其余属性原样透传。
 */
export default function StatusFlash({ status, processingStatuses, className, children, ...divProps }: StatusFlashProps) {
  const flashClass = useStatusTransition(status, processingStatuses);
  const mergedClassName = [className, flashClass].filter(Boolean).join(' ') || undefined;
  return (
    <div {...divProps} className={mergedClassName}>
      {children}
    </div>
  );
}
